module.exports = __webpack_public_path__ + "img/dusem_logo_header-2.98b9489a.png";